import { createSelector } from 'reselect'
import { AnyAction } from 'redux'
import { StringDictionary } from 'shared/types/util'
import type { GalleryConfigApi } from 'shared/types/gallery/config-api'
import type { State } from 'shared/types/gallery/state'

const INITIAL_STATE: State.FilterOptionState = {
  byId: {},
  allIds: [],
}

export function reducer(state: State.FilterOptionState = INITIAL_STATE, action: AnyAction): State.FilterOptionState {
  switch (action.type) {
    default:
      return state
  }
}

export const filterOptionByIdSelector = createSelector(
  (state: State.GlobalState) => state.filterOptions,
  (filterOptions) =>
    (id: string): GalleryConfigApi.FilterOption =>
      filterOptions.byId[id],
)

export const defaultFilterOptionIdsSelector = createSelector(
  (state: State.GlobalState) => state.filterOptions.byId,
  (filterOptionById: StringDictionary<GalleryConfigApi.FilterOption>) =>
    Object.values(filterOptionById).reduce((memo, filterOption: GalleryConfigApi.FilterOption) => {
      if (filterOption.isDefault) {
        memo.push(filterOption.value)
      }
      return memo
    }, [] as string[]),
)
